import { render, staticRenderFns } from "./ContractWork.vue?vue&type=template&id=55b9faf2&"
import script from "./ContractWork.vue?vue&type=script&lang=ts&"
export * from "./ContractWork.vue?vue&type=script&lang=ts&"
import style0 from "./ContractWork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports